export default function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex items-start justify-between mb-8 pb-6 border-b border-[#E5E5E5]" data-testid={testid || "page-header"}>
      <div>
        <div className="text-xs uppercase tracking-[0.15em] text-neutral-500 mb-2">Keskintur Portal</div>
        <h1 className="text-3xl md:text-4xl font-extrabold font-heading">{title}</h1>
        {subtitle && <p className="text-sm text-neutral-600 mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
